var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgSubway(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 31 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M14.62 2.25H9.743a2.25 2.25 0 00-2.25 2.25v5.25h7.125v-7.5zm2.25 0v7.5h7.124V4.5c0-1.219-1.031-2.25-2.25-2.25H16.87zM7.493 16.5c0 1.266.985 2.25 2.25 2.25h12a2.25 2.25 0 002.25-2.25V12h-16.5v4.5zM9.744 0h12c2.485 0 4.5 2.016 4.5 4.5v12c0 2.016-1.312 3.703-3.14 4.313l1.312 1.265c.422.469.422 1.172 0 1.594-.469.469-1.172.469-1.594 0L20.15 21h-8.859l-2.672 2.672a1.027 1.027 0 01-1.547 0c-.468-.422-.468-1.125 0-1.594l1.266-1.265c-1.781-.61-3.094-2.297-3.094-4.313v-12c0-2.484 2.016-4.5 4.5-4.5zm1.5 16.5a1.48 1.48 0 01-1.5-1.5c0-.797.656-1.5 1.5-1.5.797 0 1.5.703 1.5 1.5 0 .844-.703 1.5-1.5 1.5zm10.5-1.5c0 .844-.703 1.5-1.5 1.5a1.48 1.48 0 01-1.5-1.5c0-.797.656-1.5 1.5-1.5.797 0 1.5.703 1.5 1.5z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgSubway);
export default ForwardRef;
